import { render, staticRenderFns } from "./sysLabelHistory.vue?vue&type=template&id=6531057a&scoped=true"
import script from "./sysLabelHistory.vue?vue&type=script&lang=js"
export * from "./sysLabelHistory.vue?vue&type=script&lang=js"
import style0 from "./sysLabelHistory.vue?vue&type=style&index=0&id=6531057a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6531057a",
  null
  
)

export default component.exports